import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  useLocation,
} from 'react-router-dom';

import { AuthContextProvider, useAuthContext } from 'context/AuthContext';
import LoginScreen from 'components/LoginScreen';
import MagicLinkLogin from 'components/MagicLinkLogin';
import Home from 'components/MainScreen/Home';
import Entities from 'components/Entities';
import DynamicScreen from 'components/DynamicScreen';
import Chat from 'components/Chat';

function PrivateRoute({ component: Component, ...rest }) {
  const auth = useAuthContext();
  return (
    <Route
      {...rest}
      render={({ staticContext, ...props }) =>
        !auth.loggedIn ? (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location },
            }}
          />
        ) : (
          <Component {...rest} {...props} />
        )
      }
    />
  );
}

function NoMatch() {
  //return <Redirect to="/login"/>
  const location = useLocation();
  return <div>Not found: {location.pathname}</div>;
}

function Logout() {
  const auth = useAuthContext();
  React.useEffect(() => {
    auth.logout();
  }, [auth]);
  return <Redirect to="/login" />;
}

export default function Routes(props) {
  return (
    <AuthContextProvider>
      <Router>
        <Switch>
          <Route exact path="/login" component={LoginScreen} />
          <Route path="/goto/:magicLinkToken" component={MagicLinkLogin} />

          <PrivateRoute exact={true} path="/" component={Home} />
          <PrivateRoute exact={true} path="/advanced" component={Home} />
          <PrivateRoute exact={true} path="/logout" component={Logout} />
          <PrivateRoute path="/table/:schemaId/:id?" component={Entities} />
          <PrivateRoute
            path="/:target(reset|list|details|page|dialog|magicform|magicscreen)/:deeplink+"
            component={DynamicScreen}
          />
          <PrivateRoute
            path="/chat/:roomId?/:command/:params(.*)"
            component={Chat}
          />
          <PrivateRoute path="/chat/:roomId?" component={Chat} />
          <Route path="*" component={NoMatch} />
        </Switch>
      </Router>
    </AuthContextProvider>
  );
}
